import React, { useContext, useMemo } from 'react';

import PaymentButtonRedirect from './PaymentButtonRedirect';
import PaymentButton from './PaymentButton';
import { storeContext } from '../../context';
import {
  paymentTypes,
  paymentTypesRedirect
} from '../../../constants/mixpanel';

const PaymentButtonWrapper = props => {
  const { settings } = useContext(storeContext);
  const displayDeltaButton = useMemo(
    () => settings.get('delta_payment_button'),
    [settings]
  );

  const paymentTypesDic = useMemo(
    () => ({
      [paymentTypes.PAYMENT]: paymentTypesRedirect.PAYMENT,
      [paymentTypes.ONE_CLICK_PAYMENT]: paymentTypesRedirect.ONE_CLICK_PAYMENT,
      [paymentTypes.PAY_FULL_PLAN]: paymentTypesRedirect.PAY_FULL_PLAN,
      [paymentTypes.ASSIST_PP]: paymentTypesRedirect.ASSIST_PP,
      [paymentTypes.PP_CONVERT]: paymentTypesRedirect.PP_CONVERT,
      [paymentTypes.PP_BRING_CURRENT]: paymentTypesRedirect.PP_BRING_CURRENT,
      [paymentTypes.ADD_OUTSIDE_BALANCE]:
        paymentTypesRedirect.ADD_OUTSIDE_BALANCE
    }),
    []
  );

  const transformProps = () => ({
    ...props,
    paymentButtonType: paymentTypesDic[props.paymentButtonType]
  });
  return (
    <>
      {displayDeltaButton ? (
        <PaymentButton {...props} />
      ) : (
        <PaymentButtonRedirect {...transformProps()} />
      )}
    </>
  );
};

export default PaymentButtonWrapper;
